/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { ZumperTheme } from '../types'

export const PAD_MAPPER = 'PadMapper'

export const PadMapper: ZumperTheme = {
  name: PAD_MAPPER,
  colors: {
    accent: '#3288c4',
    accentLight: '#5ab8f8',
    background: '#EBEBEB',
    backgroundDark: '#E6E6E6',
    backgroundMedium: '#F1F1F1',
    backgroundLight: '#F9F9F9',
    backgroundLightest: '#FFFFFF',
    errorColor: '#D93364',
    neutralLight: '#C9DADE',
    primary: '#0879c4',
    primaryButton: '#51bc6a',
    primaryButtonDark: '#138496',
    primaryDark: '#23527c',
    primaryHover: '#23527c',
    primaryInactive: '#5ab8f8',
    secondary: '#51bc6a',
    secondaryDark: '#49a75f',
    secondaryHover: '#49a75f',
    secondaryInactive: '#ebe9e5',
    text: '#0A0F1C',
    textLight: '#454442',
    textLightest: '#726F6C',
  },
  typography: {
    bodyFontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    displayFontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    fontSize48: '48px',
    fontSize40: '40px',
    fontSize32: '32px',
    fontSize28: '28px',
    fontSize24: '24px',
    fontSize20: '20px',
    fontSize16: '16px',
    fontSize14: '14px',
    fontSize12: '12px',
    fontSize11: '11px',
    fontWeightBold: 700,
    fontWeightRegular: 600,
    fontWeightMedium: 500,
    fontWeightLight: 400,
  },
  spacing: {
    spacing1: '2px',
    spacing2: '4px',
    spacing3: '8px',
    spacing4: '16px',
    spacing5: '24px',
    spacing6: '32px',
    spacing7: '40px',
    spacing8: '48px',
    spacing9: '56px',
    spacing10: '64px',
  },
}
